module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mask"
  }, [_c('div', {
    staticClass: "camera-box"
  }, [_c('div', {
    staticClass: "close",
    on: {
      "click": _vm.close
    }
  }, [_vm._v("X")]), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "center",
      "font-size": "14px",
      "font-weight": "bold",
      "margin-bottom": "10px"
    }
  }, [_vm._v("请将脸对准摄像头，开始识别记录")]), _vm._v(" "), _c('video', {
    attrs: {
      "id": "video",
      "width": "600",
      "height": "400"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "iCenter"
  }, [_c('el-button', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "type": "primary",
      "size": "small",
      "icon": "el-icon-camera"
    },
    on: {
      "click": _vm.takePhone
    }
  }, [_vm._v("完成")])], 1)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "center",
      "font-size": "14px",
      "font-weight": "bold",
      "margin-bottom": "10px"
    }
  }, [_vm._v("拍摄效果")]), _vm._v(" "), _c('canvas', {
    staticStyle: {
      "display": "block"
    },
    attrs: {
      "id": "canvas",
      "width": "400",
      "height": "300"
    }
  }), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "loading": _vm.loadingbut,
      "icon": "el-icon-check",
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.takePhoneUpfile
    }
  }, [_vm._v("保存")])], 1)], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-42332f1e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/camera.vue
// module id = usha
// module chunks = 4